import { useQuery } from "@tanstack/react-query";
import { getFeatureFlags } from "./api";

const FEATURE_FLAGS_KEY = ["feature-flags"];

export function useFeatureFlags(enabled = true) {
  return useQuery({
    queryKey: FEATURE_FLAGS_KEY,
    queryFn: getFeatureFlags,
    staleTime: 60_000,
    enabled,
  });
}
